import {
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
  query,
  where,
  deleteDoc,
} from 'firebase/firestore';
import { db } from '../../../lib/firebase';
import type { Customer, EntityId } from '../../../types';

export const customerRepo = {
  async findById(id: EntityId): Promise<Customer | null> {
    const snap = await getDoc(doc(db, 'customers', id));
    return snap.exists() ? (snap.data() as Customer) : null;
  },

  async findByMobile(mobile: string): Promise<Customer | null> {
    const q = query(collection(db, 'customers'), where('mobile', '==', mobile));
    const snap = await getDocs(q);
    return snap.empty ? null : (snap.docs[0].data() as Customer);
  },

  async save(customer: Customer): Promise<void> {
    await setDoc(doc(db, 'customers', customer.id), customer, { merge: true });
  },

  async list(): Promise<Customer[]> {
    const snap = await getDocs(collection(db, 'customers'));
    return snap.docs.map((d) => d.data() as Customer);
  },

  async findByStaff(staffEmail: string): Promise<Customer[]> {
    const q = query(
      collection(db, 'customers'),
      where('assignedStaff', 'array-contains', staffEmail),
    );
    const snap = await getDocs(q);
    return snap.docs.map((d) => d.data() as Customer);
  },

  async delete(id: EntityId): Promise<void> {
    await deleteDoc(doc(db, 'customers', id));
  },
};
